var map = {
	"./1.jpg": 581,
	"./2.jpg": 1485,
	"./3.jpg": 501,
	"./4.jpg": 9842,
	"./5.jpg": 2622,
	"./6.jpg": 9095,
	"./7.jpg": 6857,
	"./8.jpg": 6136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4579;